import { Avatar, Menu, Skeleton, Typography } from 'antd';
import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import PopoverMenu from '../PopoverMenu/PopoverMenu';
import { EllipsisOutlined } from '@ant-design/icons';
import { getColorByName } from '../../utils/common';
import { useSelector } from 'react-redux';

const { Text } = Typography;

const workspaceLoader = Array.from({ length: 4 }, (v, i) => i).map((item) => ({
  key: 'skeleton',
  label: (
    <Skeleton
      active
      title={false}
      paragraph={{
        rows: 1,
        width: '80%',
      }}
      style={{
        flex: 1,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        margin: 0,
      }}
    />
  ),
  icon: <Skeleton.Avatar active size={24} shape="square" style={{ borderRadius: '6px' }} />,
}));

const WorkspaceList = ({ title, workspaceData, popoverMenuContent, loading, collapseLeftBar }) => {
  const navigate = useNavigate();
  const starredWorkspace = useSelector((state) => state.organization?.starredWorkspace);

  const workspaceItems = useMemo(
    () =>
      workspaceData?.map((item) => {
        const isStarred = starredWorkspace?.data?.find((ele) => ele?.id === item?.id);
        return {
          key: item?.id,
          label: (
            <div style={{ display: 'flex', alignItems: 'center' }} className="workspace-item">
              <Text
                ellipsis={{ tooltip: true }}
                style={{
                  flex: 1,
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  color: 'inherit',
                }}
              >
                {item?.title}
              </Text>
              <div onClick={(e) => e.stopPropagation()} className="pop-over-menu">
                <PopoverMenu
                  id={item?.id}
                  content={popoverMenuContent(isStarred)}
                  arrow={false}
                  scroll="true"
                  placement="right"
                >
                  <EllipsisOutlined />
                </PopoverMenu>
              </div>
            </div>
          ),
          icon: (
            <Avatar
              size={24}
              style={{
                backgroundColor: getColorByName(item?.title),
                borderRadius: '6px',
                color: '#fff',
              }}
            >
              {item?.title?.slice(0, 1)}
            </Avatar>
          ),
          onClick: () => {
            navigate(`/spaces/${item?.slug}`);
          },
        };
      }),
    [workspaceData, popoverMenuContent, navigate, starredWorkspace]
  );

  return (
    <div>
      {!collapseLeftBar && !loading && workspaceItems?.length > 0 && (
        <Text
          style={{
            padding: '16px 28px',
            fontWeight: 400,
            fontSize: 14,
            lineHeight: '22px',
          }}
        >
          {title}
        </Text>
      )}
      <Menu mode="inline" items={loading ? workspaceLoader : workspaceItems} />
    </div>
  );
};

export default WorkspaceList;
